import React from 'react';
import "./index.css"

const DownloadFees = () => {
  const api = process.env.REACT_APP_API;

  const handleDownloadClick = async () => {
  const token = localStorage.getItem("jwt_token");

  if (!token) {
    alert("You are not logged in. Please login first.");
    return;
  }

  try {
    const response = await fetch(`${api}/download-fees-today`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`, // ✅ FIXED
      },
    });

    if (!response.ok) {
      const text = await response.text();
      console.error("Download failed:", text);
      throw new Error('Failed to download file');
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'fees-today.xlsx';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    console.error("Download error:", error.message);
    alert(error.message);
  }
};


  return (
    <div>
      <button onClick={handleDownloadClick} className="download-button">
        Download Fees Data
      </button>
    </div>
  );
};

export default DownloadFees;

